import { props as multiProps } from 'ramda'
import React from 'react'

const hasAllPropsReady = (hydrateProps, props) => hydrateProps.reduce((acc, propKey) => acc && !!props[propKey], true)

export default function createHydrated(Wrapped) {
  return function Hydratable(props) {
    const { hydrateProps = [], hydrate = () => {}, campaignHydrateProps = [], campaignHydrate = () => {} } = props
    // biome-ignore lint/correctness/useExhaustiveDependencies: we want to only run when specific props change
    React.useEffect(() => {
      if (hydrateProps && hasAllPropsReady(hydrateProps, props)) {
        hydrate(props)
      }
    }, [...multiProps(hydrateProps, props)])
    // biome-ignore lint/correctness/useExhaustiveDependencies: we want to only run when specific props change
    React.useEffect(() => {
      if (campaignHydrateProps && hasAllPropsReady(campaignHydrateProps, props)) {
        campaignHydrate(props)
      }
    }, [...multiProps(campaignHydrateProps, props)])
    return <Wrapped {...props} />
  }
}
